import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthStore } from '@store';

@Component({
  selector: 'app-learning-space-banner',
  templateUrl: './learning-space-banner.component.html',
  styleUrls: ['./learning-space-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearningSpaceBannerComponent {
  constructor(private authStore: AuthStore) {}

  close(): void {
    this.authStore.closeLearningRoomBanner();
  }
}
